import React, { useState, useEffect } from 'react';
import { loadOrg } from '../../api/api';
import { setHead } from '../../api/settingApi';
import { useNavigate } from 'react-router-dom';
import { useNotification } from "../../context/NotificationContext";


const NewPhead = () => {
  const navigate = useNavigate();
  const notify = useNotification();
  const user = JSON.parse(sessionStorage.getItem('lgusr'));
  const isAdmin = user?.role === 'ADMINISTRATOR';
  const org_id = user?.orgId;

  const [organizations, setOrganizations] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    organizationId: isAdmin ? '' : org_id,
    hasCheckList: false,
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAdmin) {
      const fetchOrganizations = async () => {
        setLoading(true);
        try {
          const response = await loadOrg();
          setOrganizations(response);
        } catch (error) {
          console.error('Error fetching organizations:', error);
          setOrganizations([]);
        } finally {
          setLoading(false);
        }
      };
      fetchOrganizations();
    }
  }, [isAdmin]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name) {
      newErrors.name = 'Problem Head Name is required';
    }
    if (!formData.organizationId) {
      newErrors.organizationId = 'Please select an organization';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setSuccess('');

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      await setHead(formData);
      setSuccess('Problem Head created successfully!');
      notify("success", 'Problem Head created successfully!');
      setTimeout(() => {
        navigate('/settings');
      }, 2000);
    } catch (error) {
      setErrors({ submit: 'Failed to save Problem Head.' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-blue-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-10 rounded-lg shadow-lg w-full max-w-md border-t-8 border-green-500"
      >
        <h2 className="text-3xl font-extrabold mb-6 text-blue-800 text-center">
          New Problem Head
        </h2>

        {errors.submit && (
          <div className="mb-4 bg-red-600 text-white border border-red-700 p-3 rounded shadow-md flex items-start space-x-2">
            <span className="font-bold">⚠️</span>
            <span>{errors.submit}</span>
          </div>
        )}
        {success && (
          <div className="mb-4 text-green-700 bg-green-100 border border-green-300 p-3 rounded">
            {success}
          </div>
        )}

        {/* Problem Head Name */}
        <div className="mb-4">
          <label className="block text-blue-800 mb-2 font-medium">Problem Head Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-blue-300 rounded focus:outline-none focus:ring-2 focus:ring-green-400 focus:border-green-400"
            required
          />
          {errors.name && <p className="text-red-600 text-sm mt-1">{errors.name}</p>}
        </div>

        {/* Description */}
        <div className="mb-4">
          <label className="block text-blue-800 mb-2 font-medium">Description</label>
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-blue-300 rounded focus:outline-none focus:ring-2 focus:ring-green-400 focus:border-green-400"
          />
        </div>

        {/* Organization Dropdown (Admin only) */}
        {isAdmin && (
          <div className="mb-4">
            <label className="block text-blue-800 mb-2 font-medium">Organization</label>
            <select
              name="organizationId"
              value={formData.organizationId}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-blue-300 rounded focus:outline-none focus:ring-2 focus:ring-green-400 focus:border-green-400"
            >
              <option value="" disabled>Select an organization</option>
              {organizations.map((org) => (
                <option key={org.id} value={org.id}>
                  {org.name}
                </option>
              ))}
            </select>
            {errors.organizationId && (
              <p className="text-red-600 text-sm mt-1">{errors.organizationId}</p>
            )}
          </div>
        )}

        {/* Has Checklist */}
        <div className="mb-6 flex items-center">
          <input
            type="checkbox"
            id="hasCheckList"
            name="hasCheckList"
            checked={formData.hasCheckList}
            onChange={handleChange}
            className="h-4 w-4 text-green-600 border-blue-300 rounded focus:ring-green-500"
          />
          <label htmlFor="hasCheckList" className="ml-2 text-blue-800 font-medium">
            Has Checklist
          </label>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-green-500 text-white font-semibold py-3 rounded hover:bg-green-600 transition disabled:opacity-50"
        >
          {loading ? 'Saving...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

export default NewPhead;
